import { MessageFormatElement } from 'intl-messageformat-parser';

const messages: Record<string, string> | Record<string, MessageFormatElement[]> = {
    closePage: "Pagina sluiten",
    successStatus: "De betaling is geslaagd",
    successStatusInfo: "Bedankt. U hoeft niets meer te doen en kunt de pagina sluiten.",
    failedStatus: "De betaling is niet gelukt.",
    failedStatusInfo: "Wat nu? U kunt altijd de betaallink in onze mail nogmaals proberen. Eventueel zou u ook een andere betaalmethode kunnen proberen.",
    pendingStatus: "Betaling in behandeling...",
    pendingStatusInfo: "Gelieve deze pagina niet te sluiten of te refreshen, u wordt zo dadelijk doorgestuurd.",
}

export default messages;